<script setup lang="ts">
import IconButton from '@/core/elements/IconButton.vue';
import { EIcon } from 'common/enum/misc.enum';

defineProps<{
  title: string;
}>();

defineEmits<{
  close: [];
}>();
</script>

<template>
  <header
    class="flex h-header min-h-header shrink-0 items-center justify-between gap-md px-content max-md:h-18 max-md:min-h-18 max-md:px-lg"
  >
    <h1 class="truncate text-title font-medium">
      {{ title }}
    </h1>
    <IconButton type="button" size="button" :icon-name="EIcon.X" theme="text" @click="$emit('close')" />
  </header>
</template>
